var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-slider-mobile" }, [
    _c("h2", [
      _vm._v(_vm._s(_vm.slides.title) + " "),
      _c("span", [_vm._v(_vm._s(_vm.slides.title_span) + " ")])
    ]),
    _vm._v(" "),
    _c("div", { ref: "swiperContainer", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.slides.list, function(slide) {
          return _c("div", { staticClass: "swiper-slide" }, [
            _c("div", { staticClass: "-content" }, [
              _c("img", {
                staticClass: "illust",
                attrs: { src: slide.url_img }
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(slide.title))]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text",
                domProps: { innerHTML: _vm._s(slide.description) }
              }),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "link", attrs: { href: slide.url_link } },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(slide.label_link) +
                      "\n                    "
                  )
                ]
              )
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-navigation-container" }, [
        _c("div", { ref: "btnPrev", staticClass: "swiper-button-prev" }, [
          _c("svg", { staticClass: "icon icon-arrow" }, [
            _c("use", { attrs: { "xlink:href": "#icon-arrow" } })
          ])
        ]),
        _vm._v(" "),
        _c("div", { ref: "btnNext", staticClass: "swiper-button-next" }, [
          _c("svg", { staticClass: "icon icon-arrow" }, [
            _c("use", { attrs: { "xlink:href": "#icon-arrow" } })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-container" }, [
      _vm.slides.url_link_all_projects
        ? _c(
            "a",
            {
              staticClass: "btn-lozenge -pink",
              attrs: { href: _vm.slides.url_link_all_projects }
            },
            [_vm._v(_vm._s(_vm.slides.label_link_all_projects))]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }